import { ItemControleCompreGanhe } from './ItemControleCompreGanhe'

export function ListControleCompreGanhe({ list }) {
  if (!list) return null

  return list?.map((product) => <ItemControleCompreGanhe key={product.codigo_produto} product={product} />)
}
